import { Tag } from '../interface';

export const display = new Tag(
  'height=device-height, viewport-fit=cover, initial-scale=1, shrink-to-fit=no, maximum-scale=1, user-scalable=no',
  'viewport'
);
